var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from "react";
import { Loader } from "google-maps";
export const GoogleAPIContext = createContext(null);
export const GoogleAPIProvider = ({ apiKey, options, children }) => {
    const [googleObj, setGoogleObj] = useState(null);
    useEffect(() => {
        if (!apiKey || googleObj) {
            return;
        }
        const loader = new Loader(apiKey, options);
        (() => __awaiter(void 0, void 0, void 0, function* () {
            const _google = yield loader.load();
            setGoogleObj(_google);
        }))();
    }, []);
    return _jsx(GoogleAPIContext.Provider, { value: googleObj, children: children });
};
export function useGoogleAPI() {
    const context = useContext(GoogleAPIContext);
    if (context === undefined) {
        console.error("useGoogleAPI must be used within a GoogleAPIProvider");
        return null;
    }
    return context;
}
//# sourceMappingURL=GoogleAPI.js.map